exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".log{display:flex;height:100%;overflow:hidden;flex-grow:1;flex-direction:column}.log h1{font-size:20px;padding-top:32px}.log .content{display:flex;overflow:hidden;flex-grow:1;flex-direction:row}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/routes/log/style.scss
// module id = 290
// module chunks = 0